import React from 'react';

const SpyglassBrandIcon: React.FC = () => (
  <svg className="w-8 h-8" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="4" width="12" height="12" rx="2" stroke="#4F46E5" strokeWidth="2" fill="none"/> {/* Indigo-600 (Top-Left Outlined Square) */}
    {/* Sky-500 (Top-Right Diamond - Rotated Square) */}
    <rect x="18" y="4" width="12" height="12" rx="2" fill="#0EA5E9" transform="rotate(45 24 10)"/> 
    {/* Blue-500 (Bottom-Left Triangle - Pointing Up) */}
    <path d="M4 30 L16 30 L10 18 Z" fill="#3B82F6"/> 
    <circle cx="24" cy="24" r="6" fill="#A5B4FC"/>                        {/* Indigo-300 (Bottom-Right Filled Circle) */}
  </svg>
);

export default SpyglassBrandIcon;
